import { useLayoutEffect } from 'react';
import { updateMetaTag } from '@theme/js/hooks/swiss/useHeadTags/headManager';

const observerConfig = { childList: true, subtree: true, attributes: true };

export const useGameDetailsMetaTags = (data: { name?: string; content?: string; property?:string }[]) => {
    useLayoutEffect(() => {
        const addedTags = new Set<HTMLElement>();

        // Update tags initially
        data.forEach(({ name, content, property }) => {
            if (name === 'title') {
                if (document.title !== content) {
                    document.title = content || '';
                }
            } else {
                updateMetaTag(addedTags, name, content, property);
            }
        });

        const observer = new MutationObserver((mutationsList) => {
            mutationsList.forEach(() => {
                data.forEach(({ name, content, property }) => {
                    if (name === 'title') {
                        if (document.title !== content) {
                            // Temporarily disconnect the observer to not fire the infinite loop while changing the title
                            observer.disconnect();
                            document.title = content || '';
                            observer.observe(document.head, observerConfig); // Reconnect the observer
                        }
                    } else {
                        const meta = document.querySelector(`meta[name="${name}"]`);
                        if (!meta || meta.getAttribute('content') !== content) {
                            // Temporarily disconnect the observer to not fire the infinite loop while changing meta tag
                            observer.disconnect();
                            updateMetaTag(addedTags, name, content, property);
                            observer.observe(document.head, observerConfig); // Reconnect the observer
                        }
                    }
                });
            });
        });

        observer.observe(document.head, observerConfig);

        return () => {
            observer.disconnect();
            addedTags.forEach((tag) => {
                tag.remove();
            });

            document.querySelector('title')?.remove();
        };
    }, [data]);
};
